/* Jauge « livraison offerte » quand le panier n'est pas en euros (snippets/rel-cart-shipping.liquid).
   Le seuil est saisi en euros dans les réglages du thème : il est converti avec le taux Shopify Markets
   du jour (Shopify.currency.rate, euro → devise du panier). Montant approximatif, à quelques centimes près.
   Élément personnalisé : recalculé à chaque réinjection du HTML par cart.js ou cart-notification.js. */
if (!customElements.get('rel-cart-shipping')) {
  customElements.define(
    'rel-cart-shipping',
    class RelCartShipping extends HTMLElement {
      connectedCallback() {
        const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
        const thresholdEur = parseFloat(this.dataset.thresholdEur);
        const eligible = parseInt(this.dataset.eligible, 10);
        if (!(rate > 0) || !(thresholdEur > 0) || isNaN(eligible)) return;

        const threshold = Math.round(thresholdEur * 100 * rate);
        const remaining = threshold - eligible;
        const progress = Math.max(0, Math.min(100, Math.floor((eligible * 100) / threshold)));

        const text = this.querySelector('.rel-cart-shipping__text');
        const bar = this.querySelector('.rel-cart-shipping__bar');
        if (remaining > 0) {
          text.innerHTML = this.dataset.remainingHtml.replace('__AMOUNT__', this.formatMoney(remaining));
        } else {
          text.innerHTML = this.dataset.reachedHtml;
          this.classList.add('rel-cart-shipping--reached');
        }
        bar.setAttribute('aria-valuenow', progress);
        bar.querySelector('span').style.width = `${progress}%`;
        this.hidden = false;
      }

      // Reprend le format Shopify de la devise d'après le montant témoin 1234,56 (ex. « $1,234.56 », « CHF 1,234.56 »),
      // sans décimales pour un montant rond, comme money_without_trailing_zeros.
      formatMoney(cents) {
        const sample = this.dataset.moneySample || '';
        const match = sample.match(/1(\D?)234(\D)56/);
        const units = Math.floor(cents / 100);
        const decimals = String(cents % 100).padStart(2, '0');
        if (!match) return `${units}.${decimals}`;
        const [pattern, thousands, decimal] = match;
        let amount = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        if (decimals !== '00') amount += decimal + decimals;
        return sample.replace(pattern, amount);
      }
    }
  );
}
